var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"tel"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', _vm.$refs.input.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }